var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration403(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 401,
    height: 316,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.567 143.512s-13.586 12.431-7.85 34.985c3.965 15.429 16.07 55.894-27.543 54.806l1.11 9.976s43.706 5.745 50.658-31.615c7.93-42.229-16.375-68.152-16.375-68.152Z",
    fill: "#016AD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M56.567 143.512s-13.586 12.431-7.85 34.985c3.965 15.429 16.07 55.894-27.543 54.806l1.11 9.976s43.706 5.745 50.658-31.615c7.93-42.229-16.375-68.152-16.375-68.152Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M359.025 61.76H77.423V245.43h281.602V61.761Z",
    fill: "#00274D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m196.952 224.454-10.705 68.205h71.342l-16.402-68.205h-44.235Z",
    fill: "#C2CBD1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M220.134 316C320.023 316 401 311.523 401 306s-80.977-10-180.866-10c-99.89 0-180.867 4.477-180.867 10s80.977 10 180.867 10Z",
    fill: "#00274D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M359.025 203.479H77.423v41.95h281.602v-41.95Z",
    fill: "#D4DBE0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M219.803 233.316c6.248 0 11.313-5.084 11.313-11.356s-5.065-11.357-11.313-11.357-11.313 5.085-11.313 11.357c0 6.272 5.065 11.356 11.313 11.356Z",
    fill: "#EAEDF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M270.303 280.706H169.977v21.917h100.326v-21.917Z",
    fill: "#D4DBE0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M110.94 98.12s12.769 3.221 6.315 14.082c-6.455 10.862-14.387 22.119-9.043 32.001 5.344 9.882-11.9-26.291-11.9-26.291l14.628-19.793Z",
    fill: "#001326"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.327 85.03c2.722 0 4.93-2.215 4.93-4.948 0-2.733-2.208-4.948-4.93-4.948-2.723 0-4.93 2.215-4.93 4.948 0 2.733 2.207 4.949 4.93 4.949Z",
    fill: "#54708C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.984 85.03c2.722 0 4.929-2.215 4.929-4.948 0-2.733-2.207-4.948-4.929-4.948-2.723 0-4.93 2.215-4.93 4.948 0 2.733 2.207 4.949 4.93 4.949Z",
    fill: "#016AD4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.795 85.03c2.723 0 4.93-2.215 4.93-4.948 0-2.733-2.207-4.948-4.93-4.948-2.722 0-4.93 2.215-4.93 4.948 0 2.733 2.208 4.949 4.93 4.949Z",
    fill: "#009D93"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.202 298.059s-2.498 3.556-6.132 2.879c-3.635-.676-5.511 2.561-2.564 4.352 2.947 1.791 12.304-.08 12.304-.08l1.177-5.214-4.785-1.937Z",
    fill: "#016AD4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M127.288 143.512s13.296.066 17.459 27.568c4.163 27.503 9.146 73.168-36.715 73.645v-32.676l19.256-68.537Z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.22 129.197s37.509 0 41.923 20.896c4.414 20.895-19.508 83.382-19.508 83.382l-42.292-1.83s1.771-23.244-4.613-42.043c-6.383-18.8-30.186-52.577 24.49-60.405Z",
    fill: "#016AD4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M108.032 152.613s-11.895 12.033-5.895 31.098c6.001 19.065-35.327 18.574-35.327 18.574.64 3.986 1.082 8.002 1.322 12.033 0 0 18.027 13.599 45.781 10.109l1.666-4.776 7.123-17.565-14.67-49.473Z",
    fill: "#000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2 101.226s-3.64 7.194-4.38 12.643a4.059 4.059 0 0 0 .792 3.004 4.021 4.021 0 0 0 2.684 1.552 8.85 8.85 0 0 0 5.018-.486 8.895 8.895 0 0 0 3.949-3.146l4.854-5.619a7.245 7.245 0 0 0-.063-8.356c-2.98-4.734-10.815-4.038-12.854.408Z",
    fill: "#F4A28C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m109.339 113.226-7.804 20.803-14.677-2.171 11.747-15.159 10.734-3.473Z",
    fill: "#F4A28C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M99.92 102.295a32.498 32.498 0 0 0 7.094 2.257 6.71 6.71 0 0 0-2.741 6.837 5.46 5.46 0 0 0 1.837 3.205 5.438 5.438 0 0 0 3.453 1.295l3.705-9.679a8.231 8.231 0 0 0 .6-4.298 8.202 8.202 0 0 0-1.672-4.001 28.181 28.181 0 0 0-2.57-2.86c-2.261-2.268-7.076-2.013-8.805-4.873a1.927 1.927 0 0 0-3.346.001c-1.6 2.749-2.93 7.55.36 10.738a7.772 7.772 0 0 0 2.085 1.378Z",
    fill: "#00274D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M103.506 110.865s1.217-2.852 3.273-1.764c2.056 1.087.363 5.26-2.741 4.436l-.532-2.672ZM96.141 105.878l-3.254 2.027a1.327 1.327 0 0 0-.01 2.166l2.627 1.697.637-5.89Z",
    fill: "#F4A28C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M97.324 118.453s4.572-.723 6.293-2.431a11.867 11.867 0 0 1-4.086 5.59 11.807 11.807 0 0 1-6.5 2.348l4.293-5.507Z",
    fill: "#CE8172"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M111.482 146.166a10.703 10.703 0 0 1 4.427-3.013 10.667 10.667 0 0 1 10.224 1.675 10.743 10.743 0 0 1 3.244 4.27c5.061 11.94 10.863 33.167 2.193 56.225-13.216 35.251-65.58-3.661-65.58-3.661l7.93-8.624s27.543 13.068 38.473 6.275c9.067-5.638-14.511-37.293-.911-53.147Z",
    fill: "#016AD4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.482 146.166a10.703 10.703 0 0 1 4.427-3.013 10.667 10.667 0 0 1 10.224 1.675 10.743 10.743 0 0 1 3.244 4.27c5.061 11.94 10.863 33.167 2.193 56.225-13.216 35.251-65.58-3.661-65.58-3.661l7.93-8.624s27.543 13.068 38.473 6.275c9.067-5.638-14.511-37.293-.911-53.147Z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M67.074 200.48s-9.172-1.804-9.86-9.114c-.686-7.31 10.059 3.476 11.962 0 1.903-3.476 5.524-3.609 4.678 1.671l-6.78 7.443Z",
    fill: "#F4A28C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M100.406 282.935s3.225 2.905 2.115 6.448c-1.111 3.542 1.863 5.81 3.965 3.091 2.101-2.72 1.427-12.272 1.427-12.272l-5.009-1.805-2.498 4.538Z",
    fill: "#016AD4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m67.986 299.996-7.163-1.937 20.26-56.889-8.14-9.379 37.693 1.684a24.36 24.36 0 0 1-2.659 9.804 24.273 24.273 0 0 1-6.421 7.855 55.227 55.227 0 0 0-9.423 9.353 220.35 220.35 0 0 0-24.147 39.509Z",
    fill: "#00274D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m68.29 231.578-1.123 27.728a13.146 13.146 0 0 0 1.857 7.317 13.074 13.074 0 0 0 5.57 5.074l26.433 12.697 2.644-6.408-15.358-11.197a11.58 11.58 0 0 1-4.207-5.837 11.627 11.627 0 0 1 .044-7.205l7.018-21.227-22.878-.942Z",
    fill: "#00274D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M233.205 120.533h-6.873v-16.146a9.978 9.978 0 0 0-2.715-7.375 9.893 9.893 0 0 0-14.394 0 9.997 9.997 0 0 0-2.716 7.375v16.146h-6.885v-16.146a16.903 16.903 0 0 1 5.085-11.626 16.776 16.776 0 0 1 11.719-4.776c4.377 0 8.582 1.713 11.72 4.776a16.907 16.907 0 0 1 5.085 11.626l-.026 16.146Z",
    fill: "#016AD4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M233.205 120.533h-6.873v-16.146a9.978 9.978 0 0 0-2.715-7.375 9.893 9.893 0 0 0-14.394 0 9.997 9.997 0 0 0-2.716 7.375v16.146h-6.885v-16.146a16.903 16.903 0 0 1 5.085-11.626 16.776 16.776 0 0 1 11.719-4.776c4.377 0 8.582 1.713 11.72 4.776a16.907 16.907 0 0 1 5.085 11.626l-.026 16.146Z",
    fill: "#FF5751"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M242.113 108.196h-51.412v41.14h51.412v-41.14Z",
    fill: "#FF5751"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M221.072 123.147a5.461 5.461 0 0 0-3.285-5.28 5.415 5.415 0 0 0-6.075 1.252 5.461 5.461 0 0 0-1.491 4.028 5.326 5.326 0 0 0 1.758 3.981v11.568h7.454v-11.648a5.495 5.495 0 0 0 1.639-3.901Z",
    fill: "#00274D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M265.082 165.084h-97.365v20.75h97.365v-20.75Z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M265.082 165.084h-30.054v20.75h30.054v-20.75Z",
    fill: "#016AD4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M180.194 178.484a2.847 2.847 0 0 0 2.841-2.852 2.847 2.847 0 0 0-2.841-2.853 2.847 2.847 0 0 0-2.842 2.853 2.847 2.847 0 0 0 2.842 2.852ZM190.753 178.484a2.847 2.847 0 0 0 2.842-2.852 2.847 2.847 0 0 0-2.842-2.853 2.847 2.847 0 0 0-2.841 2.853 2.847 2.847 0 0 0 2.841 2.852ZM201.062 178.484a2.847 2.847 0 0 0 2.842-2.852 2.847 2.847 0 0 0-2.842-2.853 2.847 2.847 0 0 0-2.841 2.853 2.847 2.847 0 0 0 2.841 2.852ZM211.622 178.484a2.847 2.847 0 0 0 2.842-2.852 2.847 2.847 0 0 0-2.842-2.853 2.847 2.847 0 0 0-2.841 2.853 2.847 2.847 0 0 0 2.841 2.852ZM222.42 178.484a2.847 2.847 0 0 0 2.842-2.852 2.848 2.848 0 0 0-2.842-2.853 2.848 2.848 0 0 0-2.842 2.853 2.847 2.847 0 0 0 2.842 2.852Z",
    fill: "#00274D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M22.046 241.184s-13.216.372-12.542-7.774c.674-8.146 11.67-.107 11.67-.107l.872 7.881Z",
    fill: "#F4A28C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.504 198.544S-27.978 55.008 54.44 13.907C73.048 4.62 190.82-19.26 302.088 38.013",
    stroke: "#D4DBE0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.03 10.15"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M369.426 289.873s-11.247-3.091-13.692-13.612c0 0 17.432-3.529 17.921 14.594l-4.229-.982Z",
    fill: "#009D93"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M370.814 288.746s-7.864-12.471-.952-24.146c0 0 13.217 8.451 7.375 24.173l-6.423-.027Z",
    fill: "#009D93"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M372.836 288.759s4.15-13.174 16.705-15.681c0 0 2.366 8.557-8.128 15.708l-8.577-.027Z",
    fill: "#009D93"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m364.668 288.454 2.286 15.669 14.367.066 2.114-15.655-18.767-.08Z",
    fill: "#00274D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration403);
export default __webpack_public_path__ + "static/media/illustration403.5643f116ae1dc9379e1daf1de80e9a93.svg";
export { ForwardRef as ReactComponent };